module.exports = __webpack_public_path__ + "components/advertise-markets/static/guest-with-ab-659462352bb2ffe535d195974b8eeaea.jpg";